import type { ComponentDocs } from '@ui/components/helpers';

export const icNavigationDocs: ComponentDocs = {
  selector: 'ic-navigation',
  status: 'adopted',
  source: 'others',
  scope: 'ui',
  family: 'navegación',

  outputs: [
    {
      name: 'appearanceChanged',
      payload: 'FuseVerticalNavigationAppearance',
      description: 'Emite cuando cambia la apariencia del sidebar',
    },
    {
      name: 'modeChanged',
      payload: 'FuseVerticalNavigationMode',
      description: 'Emite cuando cambia el modo (side/over)',
    },
    {
      name: 'openedChanged',
      payload: 'boolean',
      description: 'Emite cuando cambia el estado abierto/cerrado',
    },
    {
      name: 'positionChanged',
      payload: 'FuseVerticalNavigationPosition',
      description: 'Emite cuando cambia la posición (left/right)',
    },
  ],

  directives: [],

  services: [],

  cssTokens: [
    { name: '--ic-navigation-width', default: '248px', description: 'Ancho consumido por el panel expandido, con fallback de 248px' },
    { name: '--ic-navigation-dense-width', default: '56px', description: 'Ancho consumido en modo denso/colapsado, con fallback de 56px' },
    { name: '--ic-navigation-height', default: '100vh', description: 'Alto consumido por el panel, con fallback de 100vh; puede definirse como 100% dentro de un marco acotado' },
  ],

  subcomponents: [],

  internals: [
    { selector: 'ic-navigation-item', folder: '_navigation-item' },
    { selector: 'ic-navigation-group', folder: '_navigation-group' },
  ],

  externalDeps: ['fuse-vertical-navigation'],

  fullPage: true,

  demos: [
    {
      slug: 'default',
      label: 'Side',
      collapseToolbar: true,
      loader: () =>
        import('app/modules/admin/examples/demos/others/navigation/demos/default/demo-navigation--default.component')
          .then(m => m.DemoNavigationDefaultComponent),
    },
    {
      slug: 'dense',
      label: 'Dense',
      collapseToolbar: true,
      loader: () =>
        import('app/modules/admin/examples/demos/others/navigation/demos/dense/demo-navigation--dense.component')
          .then(m => m.DemoNavigationDenseComponent),
    },
    {
      slug: 'over',
      label: 'Over',
      collapseToolbar: true,
      loader: () =>
        import('app/modules/admin/examples/demos/others/navigation/demos/over/demo-navigation--over.component')
          .then(m => m.DemoNavigationOverComponent),
    },
  ],
};
